<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">疫苗驱虫详情</div>
				<div class="titleR">
					<el-button type="warning" plain size="small" @click="back">返回</el-button>
				</div>
			</div>
			<div class="content">
				<div class="no">疫苗驱虫单号：{{detail.id}}</div>
				<div class="msg">
					<div class="item">
						<div class="label">顾客姓名：</div>
						<div class="value">{{detail.memberName}}</div>
					</div>
					<div class="item">
						<div class="label">手机号码：</div>
						<div class="value">{{detail.memberMobile}}</div>
					</div>
					<div class="item">
						<div class="label">项目类型：</div>
						<div class="value">{{detail.serviceTypeId==1?'疫苗':'驱虫'}}</div>
					</div>
					<div class="item">
						<div class="label">套餐名称：</div>
						<div class="value">{{detail.servicePackageName}}</div>
					</div>
					<div class="item">
						<div class="label">支付方式：</div>
						<div class="value">
							全额支付
							<!-- <el-radio-group v-model="detail.payType" disabled>
								<el-radio :label="1">全额支付</el-radio>
								<el-radio :label="2">计划支付</el-radio>
								<el-radio :label="3">套餐卡支付</el-radio>
								<el-input v-show="detail.payType==3" :rows="4" :value="detail.cardName" disabled style="width:220px"></el-input>
							</el-radio-group> -->
						</div>
					</div>
					<div class="item">
						<div class="label">宠物昵称：</div>
						<div class="value">{{detail.petName}} ({{detail.typeName}})</div>
					</div>
					<div class="item">
						<div class="label">宠物性别：</div>
						<div class="value">{{detail.sex}}</div>
					</div>
					<div class="item">
						<div class="label">宠物年龄：</div>
						<div class="value">
							{{$public.FTime(new Date(detail.birthDay).getTime(),'YYYY-MM-DD')}}
							<span style="color:#1853A4;margin-left:10px;">
								({{$public.FAge(new Date(detail.birthDay).getTime())[0]}}岁
								{{$public.FAge(new Date(detail.birthDay).getTime())[1]}}月)
							</span>
						</div>
					</div>
					<div class="item">
						<div class="label">创建人：</div>
						<div class="value">
							{{detail.createUserName}}
						</div>
					</div>
					<div class="item">
						<div class="label">创建时间：</div>
						<div class="value">
							{{$public.FTime(detail.createTime)}}
						</div>
					</div>
					<div class="item">
						<div class="label"></div>
						<div class="value">
							<div v-if="detail.beforeReplace">
								<el-button type="success" @click="dialog_batchAdd_state = true">批量添加</el-button>
								<el-button type="primary" @click="dialog_batchEdit_state = true">批量更换</el-button>
								<el-button type="danger" @click="dialog_batchDel_state = true">批量移除</el-button>
							</div>
						</div>
					</div>
				</div>
				<div class="relation">
					<div class="relationTitLine">
						<div>计划列表</div>
						<div>
							
						</div>
					</div>
					<el-table :stripe="true" :data="detail.plans" style="width: 100%" :ref="'table'">
						<el-table-column width="35">
							<template slot-scope="scope">
								<el-checkbox v-model="selectedArr[scope.$index]"
								disabled
								></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column type="expand" width="30">
							<template slot-scope="scope">
								<div class="goodsLine">
									<div class="goodsLineTit">
										<div>用药列表</div>
										<div>
											
										</div>
									</div>
									<el-table :data="scope.row.planGoods" :ref="'table'+(scope.$index)" >
										<el-table-column width="35">
											<template slot-scope="props">
												<el-checkbox v-model="selectedArrArr[scope.$index][props.$index]"
												disabled
												></el-checkbox>
											</template>
										</el-table-column>
										<el-table-column label="名称" prop="goodsName" min-width="140">
											<template slot-scope="props">
												{{props.row.dosageCeiling===1?'[ 整 ] ':''}}
												{{props.row.goodsName}}
												<span v-if="props.row.replaceType===2" style="color:#FDD000">(换)</span>
											</template>
										</el-table-column>
										<el-table-column label="规格" prop="skuValue" width="80">
										</el-table-column>
										<el-table-column label="数量" prop="num" width="80">
											<template slot-scope="props">
												<el-input
												disabled
												v-model="props.row.num"
												size="small"
												style="width:70px">
												</el-input>
											</template>
										</el-table-column>
										<el-table-column label="单位" prop="unit" width="50">
										</el-table-column>
										<el-table-column label="出库量" width="120">
											<template slot-scope="props">
												<div class="cishu">
													<el-input
													disabled
													v-model="props.row.goodsDosage"
													size="small"
													style="width:130px;">
														<template slot="append" style="padding:0;">{{props.row.outUnit}}</template>
													</el-input>
												</div>
											</template>
										</el-table-column>
										<el-table-column label="单价" prop="originalPrice" width="70">
										</el-table-column>
										<el-table-column label="换算单位" width="100">
											<template slot-scope="props">
												{{props.row.unit_changesrc}}={{props.row.unit_changedesc}}
											</template>
										</el-table-column>
										<el-table-column label="库存" width="100">
											<template slot-scope="props" >
												<span v-if="props.row.skuStocks&&props.row.skuStocks.length>0">
													{{$public.getMatchingItem(props.row.skuStocks[props.row.skuValueIndex].lstStock,'shopId',curShopId).stock}}
													{{props.row.unit}}<br>
													(共
													{{$public.getMatchingItem(props.row.skuStocks[props.row.skuValueIndex].lstStock,'shopId',curShopId).totalTimes}}
													{{props.row.outUnit}}
													)
												</span>
												<span v-else>--</span>
											</template>
										</el-table-column>
										<el-table-column label="支付状态" width="70">
											<template slot-scope="props">
												<span v-if="props.row.isPay" style="color:#18A44C">已支付</span>
												<span v-else>
													<span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
													<span v-if="!props.row.orderNum" style="color:red;">未支付</span>
												</span>
											</template>
										</el-table-column>
										<el-table-column label="小计"  width="70">
											<template slot-scope="props">
												{{$public.getSubtotal(props.row)}}
											</template>
										</el-table-column>
										<el-table-column label="是否补差价"  width="80">
											<template slot-scope="props" v-if="props.row.replaceType===2">
												<el-switch disabled :value="!props.row.notCount"></el-switch>
											</template>
										</el-table-column>
									</el-table>
								</div>
								<div style="display: flex;justify-content: space-between;font-size: 14px;padding:10px 10px;" >
										<div>
											<span>共计：</span><span style="margin-right: 70px;">
												{{plansMoney[scope.$index].count}}件
											</span>
											<span>套餐计划价：</span><span style="margin-right: 70px;">
												￥{{scope.row.planMoney}}
											</span>
											<span style="color:red">差价：</span><span style="color:red;margin-right: 50px;">
												￥{{plansMoney[scope.$index].paid===0?0:plansMoney[scope.$index].unpaid}}
											</span>
											<span style="color:#18A44C">已支付：</span><span style="color:#18A44C;margin-right: 40px;">
												￥{{plansMoney[scope.$index].paid}}
											</span>
											<span>小计：</span><span style="margin-right: 20px;">
												￥{{plansMoney[scope.$index].total}}
											</span>
										</div>
										<div>
											<span style="color:red;">总计：</span><span style="color:red;margin-right: 20px;">￥{{plansMoney[scope.$index].unpaid}}</span>
										</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="计划名称" min-width="120" prop="planName">
						</el-table-column>
						<el-table-column label="计划日期" min-width="90">
							<template slot-scope="scope">
								<div>{{$public.FTime(scope.row.planDate,'YYYY-MM-DD')}}</div>
							</template>
						</el-table-column>
						<el-table-column label="实施日期" prop="memberName" min-width="90">
							<template slot-scope="scope">
								<div>{{$public.FTime(scope.row.handlerTime,"YYYY-MM-DD")}}</div>
							</template>
						</el-table-column>
						<el-table-column label="距离下一次计划" align="center" prop="intervalDays" min-width="105">
							<template slot-scope="scope">
								{{scope.row.intervalDays}}天
							</template>
						</el-table-column>
						<el-table-column label="金额" prop="planMoney" min-width="60">
						</el-table-column>
						<el-table-column label="状态" prop="planStatus" min-width="60">
							<template slot-scope="scope">
								<span v-if="scope.row.planStatus==2" style="color:#18A44C">已完成</span>
								<span v-else style="color:red;">未完成</span>
							</template>
						</el-table-column>
						<el-table-column label="经办人" min-width="100">
							<template slot-scope="scope">
								<span v-for="(item,index) in scope.row.salesMans" :key="index">
									{{item.userName}}
								</span>
							</template>
						</el-table-column>
						<el-table-column label="支付状态" min-width="70">
							<template slot-scope="scope">
								<span v-if="scope.row.payState===1" style="color:#18A44C">已支付</span>
								<span v-if="scope.row.payState===2" style="color:#FDD000">待支付</span>
								<span v-if="scope.row.payState===3" style="color:red">未支付</span>
							</template>
						</el-table-column>
						<el-table-column label="所属门店" min-width="70">
							<template slot-scope="props">
								<span v-if="props.row.currShopId">{{$public.getShopNameById(props.row.currShopId)}}</span>
							</template>
						</el-table-column>
						<el-table-column label="备注" prop="remark" min-width="80">
						</el-table-column>
						<el-table-column label="完成备注" prop="handlerRemark" min-width="80">
						</el-table-column>
					</el-table>
					<div style="text-align: center;margin:70px 0 150px;">
						<div v-if="detail.serviceStatus==2">
							<el-button type="danger" disabled style="width:100px;margin-left:50px;">已失效</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="settlement">
			<div class="settlementL">
				<span>共计：</span><span style="font-size: 16px;margin-right: 30px;">{{totalMoney.count}}件</span>
				<span>套餐计划价：</span><span style="font-size: 16px;margin-right: 30px;">￥{{detail.packageMoney}}</span>
			</div>
			<div class="settlementR">
				<span>总计：</span><span style="font-size: 16px;margin-right: 30px;">￥{{totalMoney.total}}</span>
				<span style="color:#18A44C">已支付：</span><span style="font-size: 16px;color:#18A44C;margin-right: 50px;">￥{{totalMoney.paid}}</span>
				<span style="color:red">待支付：</span><span style="font-size: 16px;color:red;margin-right: 50px;">
					<!-- ￥{{totalMoney.paid==0?0:totalMoney.unpaid}} -->
					￥{{totalMoney.unpaid}}
				</span>
				
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				shouyinData:[],
				
				orderNumber:'',
				codeUrl:'',
				
				scopeId:'',
				propsId:'',
				propsRow:'',
				scopeIndex:0,
				cur_complete_id:'',
				
				detail:{},
				
				selectedArr:[],
				selectedArrArr:[],
				plansMoney:[],
				totalMoney:{},

				
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			ymqcParams(){
				return this.$store.state.yiliaoxin.ymqcParams;
			},
		},
		mounted(){
			this.getDetail()
		},
		methods: {
			// 返回
			back(){
				this.$store.commit("yiliaoxin/remove_router")
				if(this.$store.state.yiliaoxin.router.length===0){
					this.ymqcParams.type = 'list'
					this.$store.commit("yiliaoxin/set_ymqcParams",this.ymqcParams)
					this.$store.commit('yiliaoxin/set_curBusiness','疫苗驱虫')
				}
				// if(
				// 	this.$store.state.yiliaoxin.curBusinessPre==='工作台'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rBingli'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rYmqc'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rZhuyuan'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenDai'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenZhong'
				// ){
				// 	this.$store.commit('yiliaoxin/set_curBusiness',this.$store.state.yiliaoxin.curBusinessPre)
				// 	return 
				// }
				// this.ymqcParams.type = 'list'
				// this.$store.commit("yiliaoxin/set_ymqcParams",this.ymqcParams)
			},
			
			// 计算总价
			getTotal(){
				for(let a=0;a<this.selectedArr.length;a++){
					let total = {delPaid:0,paid:0,unpaid:0,total:0,count:0}
					if(this.selectedArr[a]){  // 选中的计划
						for(let b=0;b<this.selectedArrArr[a].length;b++){
							let goods = this.detail.plans[a].planGoods[b];
							let N = goods.allowWholesale===0?goods.countPriceDosage:goods.num;
							if(this.selectedArrArr[a][b]){ // 选中的商品
								if(goods===undefined){
									this.selectedArr.splice(a,1)
								}else{ 
									total.count = total.count + 1;
									total.total = this.$public.jia(total.total,this.$public.cheng(N,goods.price))
								}
							}
						}
						let replaceObj = {}
						for(let c=0;c<this.detail.plans[a].planGoodsAll.length;c++){
							let goods = this.detail.plans[a].planGoodsAll[c];
							let N = goods.allowWholesale===0?goods.countPriceDosage:goods.num;
							if(goods.replaceType===0&&goods.isPay!==true){ // replaceType===0 并且 未支付的金额
								total.unpaid = this.$public.jia(total.unpaid,this.$public.cheng(N,goods.price))
							}
							if(goods.isPay===true){  // 已支付
								if(goods.replaceType===0){  //  没有进行替换的
									total.paid = this.$public.jia(total.paid,this.$public.cheng(N,goods.price))
								}else if(goods.replaceType===1){
									if(goods.notCount==false){
										total.paid = this.$public.jia(total.paid,this.$public.cheng(N,goods.price))
									}else{
										var findItems = this.detail.plans[a].planGoodsAll.find((m) =>{return m.replaceMark === goods.id && m.isPay === true});
										if(findItems===undefined){
											total.paid = this.$public.jia(total.paid,this.$public.cheng(N,goods.price))
										}
									}
								}else if(goods.replaceType===2){
									if(goods.notCount===false){
										total.paid = this.$public.jia(total.paid,this.$public.cheng(N,goods.price))
									}
								}
							}
							if(!this.$public.isNull(goods.replaceMark)&&goods.isPay!==true){
								if(replaceObj[goods.replaceMark]==undefined){
									replaceObj[goods.replaceMark] = [0,0]
									replaceObj[goods.replaceMark][1] = this.$public.cheng(goods.price,N);
								}else{
									replaceObj[goods.replaceMark][1] = this.$public.jia(replaceObj[goods.replaceMark][1],this.$public.cheng(goods.price,N)<0?0:this.$public.cheng(goods.price,N))
								}
							}
						}
						for(let k in replaceObj){
							let goods = this.detail.plans[a].planGoodsAll.find((item)=>{return item.id===k}); // 被替换的商品
							let N = goods.allowWholesale===0?goods.countPriceDosage:goods.num;
							replaceObj[k][0] = this.$public.cheng(goods.price,N)
							replaceObj[k][2] = goods.notCount;
							if(replaceObj[k][2]===true){ // 补差价
								total.unpaid = this.$public.jia(total.unpaid,this.$public.jian(replaceObj[k][1],replaceObj[k][0]))
								total.delPaid = this.$public.jia(total.delPaid,replaceObj[k][0])
							}
						}
						this.plansMoney[a] = total;
					}
				}
				this.totalMoney={delPaid:0,paid:0,unpaid:0,total:0,count:0}
				for(let i=0;i<this.plansMoney.length;i++){
					if(this.selectedArr[i]){
						this.totalMoney.unpaid = this.$public.jia(this.totalMoney.unpaid,this.plansMoney[i].unpaid);
						this.totalMoney.delPaid = this.$public.jia(this.totalMoney.delPaid,this.plansMoney[i].delPaid);
						this.totalMoney.count = this.$public.jia(this.totalMoney.count,this.plansMoney[i].count);
						this.totalMoney.paid = this.$public.jia(this.totalMoney.paid,this.plansMoney[i].paid);
						this.totalMoney.total = this.$public.jia(this.totalMoney.total,this.plansMoney[i].total);
					}
				}
			},
			// 获取详情
			getDetail(){
				let params = {
					id:this.ymqcParams.curRow.id
				}
				let loading = this.$loading();
				this.$http.get('/api/MedicalPackage/Detail', params).then(res => {
					loading.close();
					if (res.code == 0) {
						if(res.data.plans==null){
							res.data.plans = []
							this.selectedArr = []
							this.selectedArrArr = []
						}else{
							for(let i=0;i<res.data.plans.length;i++){
								if(res.data.plans[i].planGoods==null){
									res.data.plans[i].planGoods=[];
								}
								for(let b=0;b<res.data.plans[i].planGoods.length;b++){
									res.data.plans[i].planGoods.allow_wholesale = res.data.plans[i].planGoods.allowWholesale;
								}
								res.data.plans[i].planGoodsAll = res.data.plans[i].planGoods
								res.data.plans[i].planGoods = this.filterPlanGoods(res.data.plans[i].planGoods)
							}
						}
						this.selectedArr=[];
						this.selectedArrArr=[];
						this.plansMoney=[]; // 每次计划的total的集合
						for(let a=0;a<res.data.plans.length;a++){
							let currPlan = true;
							if(res.data.payType===2&&!res.data.plans[a].currPlan){
								currPlan=false
							}
							this.selectedArr.push(currPlan)
							this.selectedArrArr.push([])
							this.plansMoney.push({delPaid:0,paid:0,unpaid:0,total:0,count:0})
							for(let b=0;b<res.data.plans[a].planGoods.length;b++){
								this.selectedArrArr[a].push(currPlan);
							}
						}
						// if(str=="mounted"){ // 初始化select数组
						// 	this.selectedArr=[];
						// 	this.selectedArrArr=[];
						// 	this.plansMoney=[]; // 每次计划的total的集合
						// 	for(let a=0;a<res.data.plans.length;a++){
						// 		let currPlan = true;
						// 		if(res.data.payType===2&&!res.data.plans[a].currPlan){
						// 			currPlan=false
						// 		}
						// 		this.selectedArr.push(currPlan)
						// 		this.selectedArrArr.push([])
						// 		this.plansMoney.push({delPaid:0,paid:0,unpaid:0,total:0,count:0})
						// 		for(let b=0;b<res.data.plans[a].planGoods.length;b++){
						// 			this.selectedArrArr[a].push(currPlan);
						// 		}
						// 	}
						// }else{
						// 	for(let a=0;a<res.data.plans.length;a++){
						// 		let currPlan = true;
						// 		if(this.selectedArr[a]===undefined){ // 创建了新计划
						// 			if(res.data.payType===2&&!res.data.plans[a].currPlan){
						// 				currPlan=false
						// 			}
						// 			this.selectedArr[a]=currPlan
						// 			this.selectedArrArr.push([])
						// 			this.plansMoney.push({delPaid:0,paid:0,unpaid:0,total:0,count:0})
						// 		}
						// 		for(let b=0;b<res.data.plans[a].planGoods.length;b++){
						// 			if(this.selectedArrArr[a][b]===undefined){  // 创建了新商品
						// 				if(res.data.payType===2&&!res.data.plans[a].planGoods[b].currPlan){
						// 					currPlan=false
						// 				}
						// 				this.selectedArrArr[a].push(currPlan);
						// 			}
						// 		}
						// 	}
						// }
						let arr = []
						for(let i=0;i<res.data.plans.length;i++){
							for(let a=0;a<res.data.plans[i].planGoods.length;a++){
								arr.push(res.data.plans[i].planGoods[a])
							}
						}
						this.$util.getGoodsInfo(arr).then(goodsList=>{
							for(let i=0;i<goodsList.length;i++){
								goodsList[i].allow_wholesale = goodsList[i].allowWholesale
								this.$set(goodsList[i],'skuValueIndex',0)
								goodsList[i].skuStocks = goodsList[i].skuStocks||[]
								for(let a=0;a<goodsList[i].skuStocks.length;a++){
									if(goodsList[i].skuValue==goodsList[i].skuStocks[a].skuValue){
										this.$set(goodsList[i],'skuValueIndex',a)
										// this.$set(goodsList[i],'originalPrice',goodsList[i].skuStocks[a].salePrice)
										this.$set(goodsList[i],'skus',goodsList[i].skuStocks[a].skus)
										this.$set(goodsList[i],'skuValue',goodsList[i].skuStocks[a].skuValue)
									}
								}
							}
							this.detail = res.data;
							this.getTotal();
							let ymqcExpandedIds = JSON.parse(sessionStorage.getItem('ymqcExpandedIds'))||[]
							let arr = ymqcExpandedIds[this.$route.query.id]||[]
							for(let i=0;i<this.detail.plans.length;i++){
								if(arr.indexOf(this.detail.plans[i].planId)>-1){
									this.$nextTick(()=>{
										this.$refs.table.toggleRowExpansion(this.detail.plans[i],true)
									})
								}
							}
						})
					}
				})
			},
			// 过滤
			filterPlanGoods(arr){
				let arr1 = []
				for(let i=0;i<arr.length;i++){
					if(arr[i].replaceType!==1){ // 有更换的商品
						arr1.push(arr[i])
					}
				}
				return arr1
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;padding-bottom:68px;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;padding:23px 0 20px;width:100%;height: calc(100% - 47px);box-sizing: border-box;overflow: auto;
				.no{
					font-size: 14px;color:$fontColor;font-weight: bold;padding:0 24px 24px;
				}
				.msg{
					display: flex;flex-wrap: wrap;padding:0 24px 8px;border-bottom:1px solid #f2f2f2;
					.item{
						width:20%;font-size: 12px;color:$fontColor;display: flex;padding-bottom:16px;
						.label{
							width:60px;text-align: right;
						}
						.value{
							text-align: left;
						}
					}
				}
				.relation{
					padding:10px 0 8px;
					.relationTitLine{
						display: flex;justify-content: space-between;font-size: 16px;color:$fontColor;padding:0 24px;
					}
					.goodsLine{
						background-color: #F3F6FF;border:1px solid #E4E7F8;border-radius: 4px;
						.goodsLineTit{
							display: flex;justify-content: space-between;font-size: 14px;color:$fontColor;padding:6px 16px;line-height: 32px;
						}
						::v-deep .el-table tr{
							background-color: #F3F6FF;
							th{
								background-color: #F3F6FF;border-top:1px solid #E0E2F1;border-bottom:1px solid #E0E2F1;
							}
							td{
								border-bottom:1px solid #E0E2F1;
							}
						}
					}
				}
			}
		}
		.settlement{
			position: absolute;bottom:0;width:100%;height:56px;background-color: #fff;border-radius: 12px 12px 0 0;display: flex;padding:12px 20px;box-sizing: border-box;
			.settlementL{
				width:40%;font-size: 14px;line-height: 32px;
			}
			.settlementR{
				width:60%;text-align: right;
				.text{
					color:$fontColor;font-size: 14px;padding:0px 24px 0;display: inline-block;margin-right: 20px;
				}
			}
			
		}
	}
</style>
